<template>
  <v-app>
    <v-container fluid class="error-page">
      <v-row class="logo-wrapper">
        <v-img src="@/assets/img/new_logo_domX.png" width="500" contain></v-img>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-col cols="8">
          <div class="card">
            <div class="pic-404">
              <img
                class="pic-404__parent"
                src="@/assets/img/404.png"
                alt="404"
              />
            </div>
            <p class="error-text">
              Oops. Looks like the page you're looking for no longer exists
            </p>
            <v-btn
              class="text-capitalize"
              dark
              x-large
              :color="config.light.primary"
              to="dashboard"
            >
              Back to Home
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import config from "@/config";
@Component
export default class Sidebar extends Vue {
  
  name = "Error"

  get config() {
    return config;
  }

}
</script>
<style lang="scss">
@import "../styles/app";
.error-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #284bae;
  .logo-wrapper {
    align-items: center;
    margin-bottom: 30px;

    .logo-title {
      font-size: 32px;
      font-weight: 500;
      color: white;
    }
  }
  .card {
    padding: 0 50px;
    background-color: white;
    border-radius: 4px;
    height: 680px;

    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-around;
    .error-logo {
      color: $primary;
      font-size: 148px;
      font-weight: 600;
    }
    .error-text {
      color: $primary;
      text-align: center;
      font-size: $h3-font-size;
    }
    .error-subtext {
      text-align: center;
      color: $text-grey;
      font-size: $h4-font-size;
    }
  }

  .pic-404 {
    position: relative;
    float: left;
    width: 400px;
    overflow: hidden;

    &__parent {
      width: 100%;
    }
  }
}
</style>
